import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: {
        title: '登录',
        requiresAuth: false
      }
    },
    {
      path: '/',
      component: () => import('@/components/layout/MainLayout.vue'),
      redirect: '/dashboard',
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/dashboard/Index.vue'),
          meta: {
            title: '仪表盘',
            icon: 'Monitor'
          }
        },
        {
          path: 'devices',
          name: 'Devices',
          component: () => import('@/views/device/Index.vue'),
          meta: {
            title: '设备管理',
            icon: 'Monitor'
          }
        },
        {
          path: 'alerts',
          name: 'Alerts',
          component: () => import('@/views/alerts/Index.vue'),
          meta: {
            title: '设备告警',
            icon: 'Warning'
          }
        },
        {
          path: 'accounts',
          name: 'Accounts',
          component: () => import('@/views/account/Index.vue'),
          meta: {
            title: '账号管理',
            icon: 'User'
          }
        },
        {
          path: 'messages',
          name: 'Messages',
          component: () => import('@/views/message/Index.vue'),
          meta: {
            title: '消息管理',
            icon: 'ChatDotRound'
          }
        },
        {
          path: 'users',
          name: 'Users',
          component: () => import('@/views/user/Index.vue'),
          meta: {
            title: '用户管理',
            icon: 'UserFilled'
          }
        },
        {
          path: 'tenants',
          name: 'Tenants',
          component: () => import('@/views/tenant/Index.vue'),
          meta: {
            title: '租户管理',
            icon: 'OfficeBuilding',
            requiresSuperAdmin: true
          }
        },
        {
          path: 'logs',
          name: 'Logs',
          component: () => import('@/views/log/Index.vue'),
          meta: {
            title: '操作日志',
            icon: 'Document'
          }
        },
        {
          path: 'settings',
          name: 'Settings',
          component: () => import('@/views/settings/Index.vue'),
          meta: {
            title: '系统设置',
            icon: 'Setting'
          }
        },
        {
          path: 'scripts',
          name: 'Scripts',
          component: () => import('@/views/script/Index.vue'),
          meta: {
            title: '脚本管理',
            icon: 'Code',
            requiresSuperAdmin: true
          }
        },
        {
          path: 'sensitive-words',
          name: 'SensitiveWords',
          component: () => import('@/views/sensitive-word/Index.vue'),
          meta: {
            title: '敏感词库',
            icon: 'Lock',
            requiresSuperAdmin: true
          }
        },
        {
          path: 'churn-pushes',
          name: 'ChurnPushes',
          component: () => import('@/views/churn-push/Index.vue'),
          meta: {
            title: '流失推送',
            icon: 'Bell',
            requiresSuperAdmin: true
          }
        }
      ]
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 微信多账号管理系统`
  }

  // 检查是否需要登录
  const authStore = useAuthStore()
  if (to.meta.requiresAuth && !authStore.isLoggedIn()) {
    next('/login')
  } else if (to.path === '/login' && authStore.isLoggedIn()) {
    next('/')
  }
  // 检查是否需要超级管理员权限
  else if (to.meta.requiresSuperAdmin && authStore.user?.role !== 'super-admin') {
    next('/')
  }
  else {
    next()
  }
})

export default router
